import React from 'react';
import { Menu, Tooltip } from 'antd';
import {
  FileDoneOutlined,
  DollarOutlined,
  FundOutlined,
  UploadOutlined,
  UserOutlined,
  EnvironmentOutlined,
  ToolOutlined,
  MailOutlined,
  FileOutlined,
  CheckCircleOutlined,
  RiseOutlined,
  FileSearchOutlined,
  TrophyOutlined,
  SettingOutlined
} from '@ant-design/icons';
import styles from './sider.module.sass';
import { useTheme } from 'contexts/theme';
import { useNavigate } from 'react-router-dom';
import AccessControl from 'components/AccessControl';
import isAllowedTo from 'utils/isAllowedTo';

const { Item, SubMenu } = Menu;

export default function Sider() {
  const navigate = useNavigate();
  //   const router = useRouter();
  const { dark } = useTheme();

  function handleClick(item: any) {
    navigate(item.key);
  }

  return (
    <div className={dark ? styles['sider-dark'] : styles['sider-light']}>
      <Menu
        onClick={handleClick}
        selectedKeys={[location.pathname]}
        defaultSelectedKeys={['/dashboard']}
      >
          {isAllowedTo(['Dashboard_Read']) && (
        <Item
          className={styles.active}
          key="/dashboard"
          icon={
            <Tooltip placement="right" title="Dashboard">
              <FundOutlined />
            </Tooltip>
          }
        />
      )}
      {isAllowedTo(['SamDashboard_Read']) && (
        <Item
          className={styles.active}
          key="/samdashboard"
          icon={
            <Tooltip placement="right" title="SamDashboard">
              <FundOutlined />
            </Tooltip>
          }
        />
       )}
         {isAllowedTo(['Expense_Read','Expense_Write']) && (
        <Item
          key="/expense"
          icon={
            <Tooltip placement="right" title="Expense">
              <DollarOutlined />
            </Tooltip>
          }
        />
         )}
        {/* <AccessControl permissions={['Budget_Read', 'Budget_Write']}>
          <Item key="/budget" icon={<RiseOutlined />} />
        </AccessControl> */}
        {isAllowedTo(['Budget_Read', 'Budget_Write']) && (
          <Item
            key="/budget"
            icon={
              <Tooltip placement="right" title="Budget">
                <RiseOutlined />
              </Tooltip>
            }
          ></Item>
        )}
        {isAllowedTo(['Master_Read']) && (
        <Item key="/deals" icon={<Tooltip placement="right" title="Deals"><TrophyOutlined /></Tooltip>} />
        )}
        {isAllowedTo(['Reports_Read', 'Reports_Write','Reports_MonthEndMaster','Admin_Privilege','Reports_MonthEndMasterForFluke','Reports_MfgTotals']) && (
        <Item
          key="/reports"
          icon={
            <Tooltip placement="right" title="Reports">
              <FileDoneOutlined />
            </Tooltip>
          }
        />
        )}
         {isAllowedTo(['ZipRep_Read']) && (
        <Item
          key="/zips"
          icon={
            <Tooltip placement="right" title="Zips">
              <MailOutlined />
            </Tooltip>
          }
        />
         )}
         {isAllowedTo(['Master_Read']) && (
        <Item
          key="/users"
          icon={
            <Tooltip placement="right" title="Users">
              <UserOutlined />
            </Tooltip>
          }
        />
         )}
        {isAllowedTo(['Master_Read']) && (
        <Item
          key="/manufacturers"
          disabled
          icon={
            <Tooltip placement="right" title="Manufacturers">
              <ToolOutlined />
            </Tooltip>
          }
        />
        )}
        {/* 
        <AccessControl permissions={['UploadData_Read']}>
          <Item key="/uploads" icon={<UploadOutlined />}>
            Uploads
          </Item>
        </AccessControl> */}

        {isAllowedTo(['UploadData_Read']) && (
          <Item
            key="/uploads"
            icon={
              <Tooltip placement="right" title="Uploads">
                <UploadOutlined />
              </Tooltip>
            }
          ></Item>
        )}
           {isAllowedTo(['HeatMap_Read']) && (
        <SubMenu key="map" icon={<EnvironmentOutlined />}>
          <Item key="/map">Heat Map</Item>
          <Item key="/resp-map">Resp Map</Item>
        </SubMenu>
        )}
        {isAllowedTo(['Master_Read']) && (
        <Item
          key="/verifications"
          icon={
            <Tooltip placement="right" title="Verifications">
              <CheckCircleOutlined />
            </Tooltip>
          }
        />
        )}
{isAllowedTo(['Master_Read']) && (
        <Item
          key="/nav-lookup"
          icon={
            <Tooltip placement="right" title="MFG Lookup">
              <FileSearchOutlined />
            </Tooltip>
          }
        />
)}

{isAllowedTo(['Master_Read']) && (
      <Item
          className={styles.active}
          key="/scheduler"
          icon={
            <Tooltip placement="right" title="Scheduler">
              <SettingOutlined />
            </Tooltip>
          }
        />
)}
        {isAllowedTo(['Master_Read']) && (
          <SubMenu key="/master" icon={<FileOutlined />}>
            <Item key="/master/plant-mapper">Plant Mapper</Item>
            <Item key="/master/region-mapper">Region Mapper</Item>
            <Item key="/master/privilege-screen" disabled>
              Privilege Screen
            </Item>
            <Item key="/master/manufactures">Manufactures</Item>
            <Item key="/master/distributors">Distributors</Item>
            <Item key="/master/goal-settings">Goal Settings</Item>
            <Item key="/master/dist-rep-mapper">Dist Rep Mapper</Item>
            <Item key="/master/product-family-management">
              Product Family Management
            </Item>
            <Item key="/master/products">Product</Item>
            <Item key="/master/forecasts">Forecasts</Item>
            <Item key="/master/hq-filter">Hq Filter</Item>
            <Item key="/master/territory-code-mapper">
              Territory Code Mapper
            </Item>
            <Item key="/master/dist-mfg-filter" disabled>
              Dist Mfg Filter
            </Item>
            <Item key="/master/end-user-table">End User Table</Item>
            <Item key="/master/end-user-management">End User Management</Item>
            <Item key="/master/privileges">Privileges</Item>
            {/* <Item key="/master/product-family">Product Family</Item> */}
            <Item key="/master/pipeline-part-number-mapper">
              Pipeline Part Number Mapper
            </Item>
            <Item key="/master/key-mgr">Key Manager</Item>
            <Item key="/master/naics-tool">NAICS Lookup Tool</Item>
          </SubMenu>
        )}
      </Menu>
    </div>
  );
}
